/* VivaVega theme JS — tema claro/oscuro con memoria + cantidades */
(function(){
  var KEY='vv-theme';
  function apply(t){ document.documentElement.setAttribute('data-theme', t); }
  function saved(){ try{ return localStorage.getItem(KEY); }catch(e){ return null; } }
  // init early
  apply(saved() || 'dark');

  document.addEventListener('DOMContentLoaded', function(){
    apply(saved() || 'dark');
    document.querySelectorAll('[data-theme-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var cur=document.documentElement.getAttribute('data-theme')==='light'?'light':'dark';
        var next=cur==='light'?'dark':'light';
        apply(next); try{ localStorage.setItem(KEY, next); }catch(e){}
        document.querySelectorAll('[data-theme-toggle]').forEach(syncIcon);
      });
      syncIcon(btn);
    });
    function syncIcon(btn){
      var light=document.documentElement.getAttribute('data-theme')==='light';
      var sun=btn.querySelector('[data-sun]'), moon=btn.querySelector('[data-moon]');
      if(sun&&moon){ sun.style.display=light?'none':''; moon.style.display=light?'':'none'; }
    }
    // qty steppers
    document.querySelectorAll('[data-qty]').forEach(function(box){
      var input=box.querySelector('input');
      box.querySelectorAll('[data-step]').forEach(function(b){
        b.addEventListener('click', function(){
          var v=parseInt(input.value||'1',10)||1;
          v += (b.getAttribute('data-step')==='up'?1:-1);
          if(v<1)v=1; input.value=v;
          if(box.hasAttribute('data-autosubmit')){ var f=box.closest('form'); if(f) f.submit(); }
        });
      });
    });
  });
})();
